/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactInformation
 */
export interface ContactInformation {
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    mobilePhone?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    homePhone?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    workPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    whatsappPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    secondaryEmail?: string;
    /**
     * 
     * @type {number}
     * @memberof ContactInformation
     */
    id?: number;
}

/**
 * Check if a given object implements the ContactInformation interface.
 */
export function instanceOfContactInformation(value: object): value is ContactInformation {
    return true;
}

export function ContactInformationFromJSON(json: any): ContactInformation {
    return ContactInformationFromJSONTyped(json, false);
}

export function ContactInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'mobilePhone': json['mobilePhone'] == null ? undefined : json['mobilePhone'],
        'homePhone': json['homePhone'] == null ? undefined : json['homePhone'],
        'workPhone': json['workPhone'] == null ? undefined : json['workPhone'],
        'whatsappPhone': json['whatsappPhone'] == null ? undefined : json['whatsappPhone'],
        'email': json['email'] == null ? undefined : json['email'],
        'secondaryEmail': json['secondaryEmail'] == null ? undefined : json['secondaryEmail'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function ContactInformationToJSON(json: any): ContactInformation {
    return ContactInformationToJSONTyped(json, false);
}

export function ContactInformationToJSONTyped(value?: ContactInformation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mobilePhone': value['mobilePhone'],
        'homePhone': value['homePhone'],
        'workPhone': value['workPhone'],
        'whatsappPhone': value['whatsappPhone'],
        'email': value['email'],
        'secondaryEmail': value['secondaryEmail'],
        'id': value['id'],
    };
}

